import React from 'react';
import ResponsivePagination from 'react-responsive-pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type AppPaginationProps = {
    activePage: number;
    itemsPerPage: number;
    totalItems: number;
    onPageChange: (newPage: number) => void;
}

const AppPagination: React.FC<AppPaginationProps> = ({
    activePage,
    itemsPerPage,
    totalItems,
    onPageChange}) => {
  const totalPaginas = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  return (
    <div className="d-flex align-items-center mt-3" >
      <ResponsivePagination
        containerClassName='pagination justify-content-center mb-0'
        pageItemClassName='page-item'
        pageLinkClassName='page-link f400 preto op7 bkzero'
        activeItemClassName='branco f900 bktema active'
        current={activePage}
        total={totalPaginas}
        onPageChange={(newPage) => onPageChange(newPage)}
        previousLabel={<FontAwesomeIcon icon="angle-left" />}
        nextLabel={<FontAwesomeIcon icon="angle-right" />}
      />
    </div>
  );
}

export default AppPagination;
